export const returnHomeKeyUp = history => {
      document.body.onkeyup = (e) => {
        let returnHomeTrigger = document.querySelector(".return-home-btn");
        let returnHomeIsActive = (document.activeElement === returnHomeTrigger);
        if (e.keyCode === 13 && returnHomeIsActive) {
          history.push('/');
      }
    }
}



// WEBPACK FOOTER //
// ./src/utils/returnHomeBtn.js